import { Component, ViewChild } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatDialog } from '@angular/material/dialog';
import { MatSort, Sort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { AddEditUsersComponent } from 'src/app/components/security/users/widgets/addedituser.component';
import { UserModel } from 'src/app/components/security/users/models/userModel';
import { RestAPIService } from 'src/app/services/restapi.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-users',
  templateUrl: './user.component.html'
})
export class UsersComponent {
  public pageSize = 10;
      public currentPage = 0;
      public totalSize = 0;
      @ViewChild(MatPaginator) paginator!: MatPaginator;
      @ViewChild(MatSort) sort!: MatSort;
      userList: UserModel[] = [];
      sortedUserList: UserModel[] = [];
      userModel: UserModel = new UserModel();
      dataSource = new MatTableDataSource<UserModel>();
      isAdvanceSearchFilter: boolean = false;
      filterKey: string = '';
      currentSort!: Sort;
      selectedProductCode!: string;

      displayedColumns = ['username', 'firstName','lastName','email', 'action'];

      constructor(public _restAPI: RestAPIService,
        public dialog: MatDialog) {
        }

    ngOnInit() {
        if (localStorage["applyUserFilterValue"] === 'true') {
            this.getUserList(localStorage["userFilterValue"]);
        }
        else {
            this.getUserList('');
        }
        localStorage["applyUserFilterValue"] = '';
    }

    onDisplayFilter(e : any) {
        this.isAdvanceSearchFilter = !this.isAdvanceSearchFilter;
        if(e) {
            e.stopPropagation();
        }
    }

    applyFilter(filterValue: string) {
        if (this.dataSource?.paginator) {
            this.dataSource.paginator.pageIndex = 0;
        }
        filterValue = filterValue.trim();
        filterValue = filterValue.toLowerCase();
        localStorage["userFilterValue"] = filterValue;
        this.dataSource.filter = filterValue;
    }

    openUserDialog(roleModel: UserModel): void {
        const dialogRef = this.dialog.open(AddEditUsersComponent, {
            width:"700px",
            data: roleModel
        });

        dialogRef.afterClosed().subscribe(result => {
            this.userModel = new UserModel();
            if (result) {
                this.getUserList(localStorage["userFilterValue"]);
            }
            localStorage["applyUserFilterValue"] = '';
        });
    }

    async getUserList(filterValue : any) {
        this._restAPI.get<UserModel[]>(environment.apiURL + 'api/usermanagement/list').subscribe({
            next: (data) => {
                this.userList = data;
                this.sortedUserList = this.userList.slice();
                this.totalSize = this.sortedUserList.length;
                this.dataSource.data = data;
                this.dataSource.filter = filterValue;
                this.filterKey = filterValue;
                this.dataSource.sort = this.sort;
                this.dataSource.paginator = this.paginator;
            },
            error: (error) => console.error(error)
        });
    }

    sortRoles(sort: Sort) {
        if (this.dataSource?.paginator) {
            this.dataSource.paginator.pageIndex = 0;
        }
        this.dataSource.filter = "";
        this.filterKey = "";
        this.currentSort = sort;
        this.pageSize = 10;
        this.currentPage = 0;
        this.sortUserArray(this.userList.slice(), this.currentSort);
        this.dataSource.data = this.sortedUserList;
    }

    private sortUserArray(roles: UserModel[], sort: Sort): void {
        if (sort === undefined || !sort.active || sort.direction === '') {
            this.sortedUserList = roles.slice();
            return;
        }

        this.sortedUserList = roles.sort((a, b) => {
            const isAsc = sort.direction === 'asc';
            switch (sort.active) {
                case 'username': return compare(a.username ?? '', b.username ?? '', isAsc);
                case 'firstName': return compare(a.firstName ?? '', b.firstName ?? '', isAsc);
                case 'lastName': return compare(a.lastName ?? '', b.lastName ?? '', isAsc);
                case 'email': return compare(a.email ?? '', b.email ?? '', isAsc);
                default: return 0;
            }
        });

        const part = this.sortedUserList.slice();
        this.sortedUserList = [];
        for (const user of part) {
            this.sortedUserList.push(user);
        }
    }
}

function compare(a: number | string, b: number | string, isAsc: boolean) {
    return (a < b ? -1 : 1) * (isAsc ? 1 : -1);
}